import { Component, OnInit } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { EmailSentComponent } from '../../../modals/email-sent/email-sent.component';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';
import * as CryptoJS from 'crypto-js';


@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],
})
export class ChatComponent implements OnInit {
  email_body: any;
  replay_email: any;
  user: any;
  displayMessage: any;
  decrypted: any
  userEn = 'userEncrpto'
  constructor(
    private sidenav: SideNavService,
    private mapService: MapServiceService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    if (!this.sidenav.replay_email) {
      this.decrypted = localStorage.getItem('user') || '';
      if(this.decrypted) {
        const decrypted = CryptoJS.AES.decrypt(this.decrypted, this.userEn);
        const user = decrypted.toString(CryptoJS.enc.Utf8);
        if (user) {
          this.user = JSON.parse(user);
          this.replay_email = this.user.email;
        }
      }
    } else {
      this.replay_email = this.sidenav.replay_email;
    }
    this.displayMessage = this.mapService.chat_display_message || 'None';
    if (this.sidenav.email_body) {
      this.email_body = this.sidenav.email_body;
    }
  }
  //closing chat button
  closeChat() {
    this.sidenav.chat(false);
  }

  //updating email value to service variable for state handle
  onChangeEmail(event: any): void {
    this.sidenav.replay_email = event.target.value;
  }

  //updating email body value to service variable for state handle
  onChangeEmailBody(event: any) {
    this.sidenav.email_body = event.target.value;
  }

  //for sending email and close chat after sending
  sendEmail(): void {
    //api call here only triggered when user is login
    if (this.user.email) {
      this.mapService
        .sendEmailThroughChat(this.replay_email, this.email_body)
        .subscribe((res: any) => {
          if (res.success) {
            this.sidenav.chat(false);
            this.dialog.open(EmailSentComponent, {
              panelClass: 'app-full-bleed-dialog-email-sent',
            });
          }
        });
    }
  }
}
